<template>
  <div id="home-fix-box">

    <h3 class="text-center">Predictions</h3>
    
    <v-tabs class="mb-4" show-arrows :value="weekNumMinusOne" center-active background-color="primary">
      <v-tabs-slider color="secondary"></v-tabs-slider>
      <v-tab
        id="home-week-tabs"
        v-for="i in maxPlayWeek"
        :key="i"
        @click="changeWeek(i)"
      >
        Week {{ i }}
      </v-tab>
    </v-tabs>

    <div id="points-row">
        <v-row>
          <v-col class="points-col text-center py-0" cols="4">Result Points: {{ resultPoints }}</v-col>
          <v-col class="points-col text-center py-0" cols="4">Score Points: {{ scorePoints }}</v-col>
          <v-col class="points-col text-center py-0" cols="4">Total Points: {{ resultPoints + scorePoints }}</v-col>
        </v-row>
    </div>

    <fixtures :week_id="weekNumId" v-if="weekNumId"></fixtures>
    
  </div>
</template>

<script>
import Fixtures from "@/components/Fixtures";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "HomeFixturesBox",
  props: [],
  components: {
    Fixtures,
  },
  data: () => ({
    weekNum: null,
  }),
  computed: {
    ...mapGetters([
      "weekInfo", 
      "weeks", 
      "maxGameWeek", 
      'weekGames', 
      'user'
    ]),
    maxPlayWeek() {
      if (this.maxGameWeek && this.weeks) {
        return this.weeks.find((week) => week.id === this.maxGameWeek).play_week_num;
      }
    },
    weekNumId() {
      if (this.weeks) {
        return this.weeks.find((week) => week.play_week_num === this.weekNum).id;
      }
    },
    weekNumMinusOne() {
      return this.weekNum - 1;
    },
    myPredictions() {
      if (this.weekGames) {
        let preds = [];
        this.weekGames.forEach(game => {
          let myPred = game.predictions.filter( pred => pred.user_id === this.user.id )
          preds.push(myPred);
        });
        return preds;
      }
    },
    resultPoints() {
      let res;
      if (this.myPredictions) {
        res = 0;
        this.myPredictions.forEach( pred => {
          if (pred.length) {
            res += pred[0].result_points;
          } else {
            res ++;
          }
        })
      } else {
        res = 10;
      }
      return res;
    },
    scorePoints() {
      let scr;
      if (this.myPredictions) {
        scr = 0;
        this.myPredictions.forEach( pred => {
          if (pred.length) {
            scr += pred[0].score_points;
          } else {
            scr ++;
          }
        })
      } else {
        scr = 10;
      }
      return scr;
    }
  },
  methods: {
    ...mapActions(["getGames"]),
    changeWeek(week) {
      this.weekNum = week;
    }
  },
  created() {
    this.weekNum = this.weekInfo.play_week_num;

    this.unwatchWeek = this.$store.watch(
      (state, getters) => getters.weekInfo,
      (newValue, oldValue) => {
        this.weekNum = this.weekInfo.play_week_num;
        this.getGames(this.weekInfo.id);
      }
    );
  },
};
</script>

<style scoped>

    #home-fix-box {
        background: var(--v-primary-base);
        border: 2px solid var(--v-secondary-base);
        /* border-radius: 10px; */
        padding: 1rem 0;
    }

    #points-row {

        background: #f5c159;
        border-top: 1px solid var(--v-secondary-base);
        border-bottom: 1px solid var(--v-secondary-base);
        padding: 1rem;
    }

</style>
